import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../../context/authContext';

const SigninOidc: React.FC = () => {
  const { userManager } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    const handleSigninRedirect = async () => {
      try {
        const user = await userManager.getUser();
        
        // If we already have a valid user, just go to the home page
        if (user && !user.expired) {
          navigate('/');
          return;
        }
        
        await userManager.signinRedirectCallback();
        navigate('/');
      } catch (error) {
      }
    };

    handleSigninRedirect();
  }, [userManager, navigate]);

  return <div>Signing in...</div>;
};

export default SigninOidc;